import MessagingIntegrationsPage from '../common/MessagingIntegrationsPage';

export default function AdminMessagingIntegrations() {
  return <MessagingIntegrationsPage isAdminView />;
}
